export const showRecaptcha = (env: any) =>
  ["production", "staging"].includes(env);

export const turnstileEnabled = (env: any) =>
  ["production", "staging", "development"].includes(env);
